import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationService {

  constructor(public http : HttpClient) { }
  baseUrl = environment.baseUrl;


  pushnotificationList(obj:any,token:any) {
    var httpOptions;
    httpOptions = {
      headers: new HttpHeaders({
        "accessToken":token
      })
    }
    return this.http.get(this.baseUrl + `/getNotification?limit=${obj.limit}&offset=${obj.offset}&search=${obj.search}`,httpOptions);
  }

  pushnotificationAdd(obj:any,token:any){
    var httpOptions;
    httpOptions = {
      headers: new HttpHeaders({
        "accessToken":token,
        "Content-Type":"application/json"
      })
    }
    return this.http.post(this.baseUrl + `/sendPushNotification`,obj, httpOptions);
  }

}
